import { ReactNode } from 'react';
import { Interpolation, Theme } from '@emotion/react';
import { CallInsightHeader } from './call-insight-header';

export interface ScreenLayoutProps {
  header: ReactNode;
  content: ReactNode;
  contentStyles?: Interpolation<Theme>;
  panelStyles?: Interpolation<Theme>;
  onClose: () => void;
}

export const ScreenLayout: React.FC<ScreenLayoutProps> = ({ header, content, panelStyles, contentStyles, onClose }) => (
  <div css={panelStyles}>
    <CallInsightHeader onClose={onClose}>{header}</CallInsightHeader>
    <div css={contentStyles}>{content}</div>
  </div>
);
